module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "plano_modal"
  }, [_c('b-card', [_c('label', [_c('h3', [_vm._v("Edit Hook")])]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Fixed:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.fixed),
      callback: function($$v) {
        _vm.fixed = $$v
      },
      expression: "fixed"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("X:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.x),
      callback: function($$v) {
        _vm.x = $$v
      },
      expression: "x"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Y:")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('NumberInput', {
    model: {
      value: (_vm.y),
      callback: function($$v) {
        _vm.y = $$v
      },
      expression: "y"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-button-toolbar', [_c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.validate();
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-379e5833","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_hook.vue
// module id = 3121
// module chunks = 0